module.exports = __webpack_public_path__ + "img/56_78.bc1702ad.png";